import React, { useState } from 'react';
import './SystemSettings.css';

const SystemSettings = () => {
  const [settings, setSettings] = useState({
    systemName: 'ASTOS ERP Sistemi',
    dbConnection: 'Host=localhost;Port=5432;Database=astosdb;Username=postgres;Password=postgres',
    redisConnection: 'localhost:6379',
    logLevel: 'info'
  });

  const handleSave = () => {
    // Save settings logic here
    alert('Ayarlar kaydedildi!');
  };

  return (
    <div className="system-settings">
      <div className="page-header">
        <h2>Sistem Ayarları</h2>
        <p>Sistem konfigürasyonunu yönetin</p>
      </div>

      <div className="settings-form">
        <div className="form-group">
          <label className="form-label">Sistem Adı</label>
          <input
            type="text"
            className="form-input"
            value={settings.systemName}
            onChange={(e) => setSettings({...settings, systemName: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Veritabanı Bağlantısı</label>
          <input
            type="text"
            className="form-input"
            value={settings.dbConnection}
            onChange={(e) => setSettings({...settings, dbConnection: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Redis Bağlantısı</label>
          <input
            type="text"
            className="form-input"
            value={settings.redisConnection}
            onChange={(e) => setSettings({...settings, redisConnection: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Log Seviyesi</label>
          <select
            className="form-input"
            value={settings.logLevel}
            onChange={(e) => setSettings({...settings, logLevel: e.target.value})}
          >
            <option value="debug">Debug</option>
            <option value="info">Info</option>
            <option value="warning">Warning</option>
            <option value="error">Error</option>
          </select>
        </div>

        <div className="form-actions">
          <button className="btn btn-success" onClick={handleSave}>
            💾 Ayarları Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default SystemSettings; 